<template>
  <!-- text field when editing -->
  <v-text-field
    v-if="value[index].editing"
    ref="inputRef"
    v-model="value[index][editField]"
    dense
    :rules="rules"
    :label="label"
    append-outer-icon="fa-check"
    @click:append-outer="editValue(false)"
    @keydown.enter="editValue(false)"
    @blur="editValue(false, true)"
    @update:error="editValueErrorHandler($event)"
  />
  <!-- readonly text field when not editing -->
  <v-text-field
    v-else
    ref="inputRef"
    v-model="value[index][editField]"
    dense
    readonly
    :append-outer-icon="mode == 'edit' ? 'fa-edit' : null"
    :rules="rules"
    :label="label"
    :error="value[index].error"
    @click:append-outer="editValue(true)"
    @dblclick="mode == 'edit' ? editValue(true) : undefined"
  />
</template>

<script>
export default {
  name: "EditSettingTextField",
  props: {
    value: Array,
    originalItemArray: Array,
    index: Number,
    rules: Array,
    idField: String,
    editField: String,
    label: String,
    mode: String
  },
  mounted() {
    if (this.value[this.index].editing) {
      this.$refs.inputRef.focus();
    }
  },
  methods: {
    // on / off edit item handler
    editValue(edit) {
      // set item edit mode
      let item = this.value[this.index];
      item.editing = edit;
      this.$emit("update");
      if (!edit) {
        // stop editing -> set item change state
        let originalItem = this.originalItemArray.find(
          elem => elem[this.idField] == item[this.idField]
        );
        item.changed =
          !originalItem || item[this.editField] != originalItem[this.editField];
      }
    },
    editValueErrorHandler(error) {
      this.value[this.index].error = error;
    }
  }
};
</script>
